/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApplicantApplicationUrlService {

    /**
     * Get the applicant-facing continue-application URL
     * Returns the URL the applicant uses to view/continue their own application. That URL requires no applicant auth of its own, so this endpoint is restricted to WX service-to-service tokens: a WX-signed JWT with the Fountain API audience. An account API token or an employer user session token is rejected.
     * @param applicantExternalId Applicant external ID
     * @param authorization Bearer <WX service JWT>
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiWxApplicantsApplicationUrl(
        applicantExternalId: string,
        authorization: string,
    ): CancelablePromise<{
        application_url: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/applicants/{applicant_external_id}/application_url',
            path: {
                'applicant_external_id': applicantExternalId,
            },
            headers: {
                'Authorization': authorization,
            },
            errors: {
                401: `Unauthorized`,
                404: `not found`,
            },
        });
    }

}